import { Link } from "react-router-dom";

import HealthBadge from '../HealthBadge';

import ClusterNode from '../../../types/cluster/ClusterNode';
import HostTarget from '../../../types/host/HostTarget';

interface ClusterNodesTableProps {
    nodes: ClusterNode[],
    hosts: HostTarget[]
}

function ClusterNodesTable(props: ClusterNodesTableProps) {
    const { nodes, hosts } = props;

    return (
        <div className='table-responsive'>
            <table className="table">
                <thead>
                <tr>
                    <th>Node</th>
                    <th>State</th>
                    <th>Resource groups</th>
                    <th>Monitored host</th>
                </tr>
                </thead>
                <tbody>
                {nodes.map(node => {
                    // Cross-link to the Hosts screen when the cluster node is also a monitored host.
                    const host = node.hostid !== null
                        ? hosts.find(item => Number(item.id) === Number(node.hostid))
                        : hosts.find(item => item.name.toLowerCase() === node.name.toLowerCase());
                    return (
                        <tr key={node.id}>
                            <td className="fw-bold">
                                <i className="fal fa-server fa-fw me-1" aria-hidden="true"/>
                                {node.name}
                            </td>
                            <td><HealthBadge value={node.state}/></td>
                            <td>{node.resourcegroups.length ? node.resourcegroups.join(', ') : <span className="text-muted">None</span>}</td>
                            <td>
                                {host
                                    ? <Link to={`/hosts/${host.id}`}>{host.name}</Link>
                                    : <span className="text-muted">Not monitored</span>}
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
}

export default ClusterNodesTable;
